import R from "ramda";
import {
  SET_USER_SETTINGS,
  UPDATE_USER_EMAIL,
  UPDATE_USER_NAME,
  SET_FAVOURITE_ACCOUNT,
  UPDATE_FAVOURITE_ACCOUNT,
  SET_DEFAULT_INTERFACE,
  UPDATE_DEFAULT_INTERFACE,
  UPDATE_DEFAULT_INTERFACE_LOADING,
  UPDATE_DEFAULT_INTERFACE_LOADING_STOP
} from "actions/user-settings-actions";

export const initialState = {
  email: null,
  favouriteAccountId: null,
  isBetaDefault: false,
  isBetaDefaultLoading: true,
  isFavouriteAccountLoading: true,
  isUpdateDefaultInterfaceLoading: false,
  isUserNameLoading: true,
  name: null,
  surname: null
};

export const userSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_SETTINGS:
      return stateForSetUserSettings(state, action);
    case UPDATE_USER_EMAIL:
      return R.merge(state, { email: action.data.email });
    case UPDATE_USER_NAME:
      return R.merge(state, { name: action.data.userDetails.name, surname: action.data.userDetails.surname });
    case SET_FAVOURITE_ACCOUNT:
      return R.merge(state, { favouriteAccountId: action.data.accountId, isFavouriteAccountLoading: false });
    case UPDATE_FAVOURITE_ACCOUNT:
      return R.merge(state, { favouriteAccountId: action.data.accountId });
    case UPDATE_DEFAULT_INTERFACE:
    case SET_DEFAULT_INTERFACE:
      return R.merge(state, { isBetaDefault: action.data.isBetaDefault, isBetaDefaultLoading: false });
    case UPDATE_DEFAULT_INTERFACE_LOADING:
      return R.merge(state, { isUpdateDefaultInterfaceLoading: true });
    case UPDATE_DEFAULT_INTERFACE_LOADING_STOP:
      return R.merge(state, { isUpdateDefaultInterfaceLoading: false });
    default:
      return state;
  }
};

const stateForSetUserSettings = (state, action) => (
  R.merge(state, {
    email: action.data.email,
    isUserNameLoading: false,
    name: action.data.name,
    surname: action.data.surname
  })
);



// WEBPACK FOOTER //
// ./src/js/reducers/user-settings-reducer.js